import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { colorByAlertStatus, TicketFaultStatus } from '@shared/services';


@Component({
  selector: 'app-alert-fault-status',
  templateUrl: './alert-fault-status.component.html',
  styleUrls: ['./alert-fault-status.component.scss'],
  standalone: false
})
export class AlertFaultStatusComponent implements OnChanges {

  @Input() faultStatus: TicketFaultStatus;
  @Input() fontSize: string;
  @Input() textOnly: boolean;

  badgeStyle: string;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.textOnly || changes.faultStatus) {
      if (this.faultStatus && !this.textOnly) {
        const textBgClass = 'text-bg-' + colorByAlertStatus.get(this.faultStatus);
        this.badgeStyle = 'badge rounded-pill ' + textBgClass;
      } else {
        this.badgeStyle = null;
      }
    }
  }

}
